export class ActionStateModel {
    public editMode = false;
    public currentItemIndex: number | null = null;    
}